import Picker from '../picker';
import TimePanel from '../panel/time';
import TimeRangePanel from '../panel/time-range';

export default {
  mixins: [Picker],

  name: 'ZkTimePicker',

  props: {
    isRange: Boolean
  },

  created() {
    this.type = this.isRange ? 'timerange' : 'time';
    this.panel = this.isRange ? TimeRangePanel : TimePanel;
  }
};



// WEBPACK FOOTER //
// ./src/packages/date-picker/src/picker/time-picker.js